import { render } from "./Responsibility.vue?vue&type=template&id=158b1ada&scoped=true"
const script = {}

import "./Responsibility.vue?vue&type=style&index=0&id=158b1ada&scoped=true&lang=scss"

import exportComponent from "C:\\project\\OfficialWebsite360\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-158b1ada"]])

export default __exports__